var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.48,
    y: 0.48,
    width: 23.04,
    height: 23.04,
    rx: 4.32,
    stroke: "#D1D5DB",
    strokeWidth: 0.96
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3169_3882",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3169_3882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1855 15.6C8.2155 15.6 8.2455 15.597 8.2755 15.5925L10.7985 15.15C10.8285 15.144 10.857 15.1305 10.878 15.108L17.2365 8.7495C17.2504 8.73562 17.2614 8.71914 17.269 8.70099C17.2765 8.68285 17.2804 8.6634 17.2804 8.64375C17.2804 8.6241 17.2765 8.60465 17.269 8.58651C17.2614 8.56836 17.2504 8.55188 17.2365 8.538L14.7435 6.0435C14.715 6.015 14.6775 6 14.637 6C14.5965 6 14.559 6.015 14.5305 6.0435L8.172 12.402C8.1495 12.4245 8.136 12.4515 8.13 12.4815L7.6875 15.0045C7.67291 15.0849 7.67812 15.1676 7.70269 15.2454C7.72726 15.3233 7.77044 15.3941 7.8285 15.4515C7.9275 15.5475 8.052 15.6 8.1855 15.6ZM9.1965 12.984L14.637 7.545L15.7365 8.6445L10.296 14.0835L8.9625 14.319L9.1965 12.984ZM17.52 16.86H6.48C6.2145 16.86 6 17.0745 6 17.34V17.88C6 17.946 6.054 18 6.12 18H17.88C17.946 18 18 17.946 18 17.88V17.34C18 17.0745 17.7855 16.86 17.52 16.86Z",
    fill: "#374151"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.df9827bf94d0f06ce67d3803abf467ff.svg";
export { ForwardRef as ReactComponent };